import { useAvailableTenants } from '@/api/hooks/useAvailableTenants'
import { fetchClient } from '@api/typedClient'
import { CrossroadsMapping } from '@api/types'
import { useQuery } from '@tanstack/react-query'

export function useLinkedMappings(goid: string | undefined) {
  const { availableTenants } = useAvailableTenants()
  const getMappingsFrom = availableTenants.map((at) => at.name).join(',')

  return useQuery({
    queryKey: ['mappings', goid],
    queryFn: async () => {
      const { data, error } = await fetchClient.GET(
        // @ts-expect-error TODO: Add /crossroads/entity/object/{goid} to OpenAPI spec
        `/crossroads/entity/object/${goid}`,
        {
          params: {
            query: {
              get_mappings_from: getMappingsFrom,
            },
          },
        },
      )

      if (error) {
        throw new Error(
          `Failed to fetch linked mappings: ${JSON.stringify(error)}`,
        )
      }

      const response = data as unknown as {
        mappings: Record<string, CrossroadsMapping[]>
      }
      const mappingsDict = response.mappings
      const mappingsList: CrossroadsMapping[] = []
      Object.keys(mappingsDict).forEach((tenant) => {
        mappingsDict?.[tenant]?.forEach((m: CrossroadsMapping) => {
          m.tenant = tenant
          mappingsList.push(m)
        })
      })
      return mappingsList
    },
    enabled: !!goid,
  })
}
